/**
 * Universal Client-Side Tracking & DataLayer Dispatcher
 * Dispatches to window.dataLayer for GTM and /api/collect for Server-Side Tracking / CAPI
 */

export function trackDataLayerEvent(eventName, params = {}) {
  if (typeof window === 'undefined') return;

  // 1. Client-Side DataLayer Push for GTM
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...params
  });

  // 2. First-Party Server-Side Tracking & CAPI Proxy
  try {
    fetch('/api/collect', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        eventName,
        params,
        url: window.location.href,
        referrer: document.referrer
      })
    }).catch(() => {});
  } catch (err) {
    // Silently fail without interrupting user experience
  }
}

export function trackLeadEvent(service, budget, source) {
  trackDataLayerEvent('generate_lead', {
    lead_service: service || 'Growth Audit',
    lead_budget: budget || '$1,000 - $5,000',
    lead_source: source || 'modal',
    currency: 'USD'
  });
}

export function trackToolUseEvent(toolSlug, category) {
  trackDataLayerEvent('use_tool', {
    tool_slug: toolSlug,
    tool_category: category || 'general'
  });
}

export function trackAssetDownloadEvent(assetSlug, category) {
  trackDataLayerEvent('download_asset', {
    asset_slug: assetSlug,
    asset_category: category || 'vault'
  });
}
